export default __webpack_public_path__ + "static/char-50-anr-01707f5b4e33bec738e8a2705ec9d291.webp";